import { render, staticRenderFns } from "./BoxRow.vue?vue&type=template&id=ea1dbae0"
import script from "./BoxRow.vue?vue&type=script&lang=js"
export * from "./BoxRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports